var deriveButtonProps = function (buttonProps) {
    var variant = buttonProps.variant;
    var derived = {};
    switch (variant) {
        case 'primary':
            derived.variant = 'contained';
            derived.color = 'primary';
            break;
        case 'secondary':
            derived.variant = 'outlined';
            derived.color = 'secondary';
            break;
        case 'tertiary':
            derived.variant = 'contained';
            derived.color = 'secondary';
            break;
        case 'text':
            derived.variant = 'text';
        case 'ghost':
            derived.variant = 'text';
            break;
        case 'success':
            derived.variant = 'contained';
            break;
        case 'info':
            derived.variant = 'contained';
            break;
        case 'warning':
            derived.variant = 'contained';
            break;
        case 'error':
            derived.variant = 'contained';
            break;
        default:
            derived.variant = variant;
            break;
    }
    return derived;
};

export { deriveButtonProps };
//# sourceMappingURL=deriveButtonProps.js.map
